import React, { useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import StepWrapper from "./StepWrapper";

const DateSelectStep = ({ data, onSubmit, totalSteps }) => {
  useEffect(() => {
    if (!data.date) {
      onSubmit({ date: new Date() });
    }
  }, []);

  return (
    <StepWrapper
      step={data.step}
      total={totalSteps}
      onPrev={() => onSubmit({ step: data.step - 1 })}
      onNext={() => onSubmit({ step: data.step + 1 })}
    >
      <Form.Group>
        <Form.Label>Date</Form.Label>
        <DatePicker
          selected={data.date}
          onChange={(d) => onSubmit({ date: d })}
          className="form-control"
          showTimeSelect
          timeFormat="HH:mm"
          timeIntervals={15}
          dateFormat="dd/MM/yyyy, h:mm aa"
          placeholderText="Select date and time"
          maxDate={new Date()}
        />
        <Button
          size="sm"
          variant="secondary-outlined"
          onClick={() => onSubmit({ date: new Date() })}
        >
          Set Now
        </Button>
      </Form.Group>

      <Form.Group>
        <Form.Label>Note</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          placeholder="Type Here"
          value={data.note || ""}
          onChange={(e) => onSubmit({ note: e.target.value })}
        />
      </Form.Group>
    </StepWrapper>
  );
};

export default DateSelectStep;
